'use strict';

angular.module('chatEngine.engines.keyword', ['uuid4', 'chatEngine.dialog', 'chatEngine.services'])

.controller('KeywordEngineCtrl', ['$scope', '$http', '$location', '$modal', 'uuid4', 'Dialog', 'mixpanelService',
    'Engine', 'messageService', '$timeout',
    function($scope, $http, $location, $modal, uuid4, Dialog, mixpanelService, Engine, messageService, $timeout) {
    $scope.defaultWelcomeMessage = [{
        'body': 'Hey, I\'m new to Kik!',
        'type': 'text'
    }];
    $scope.inflight = false;
    $scope.pendingChanges = false;
    $scope.newKeywordsMessages = {messages: [], keywords: []};

    $scope.canActivate = function() {
        return $scope.defaultMessages.length > 0;
    };

    $scope.$watch('newKeywordsMessages', function() {
        if ($scope.newKeywordsMessages.messages.length || $scope.newKeywordsMessages.keywords.length) {
            $scope.addNewKeywordsMessages();
        }
    }, true);

    $scope.formatEngineResponseData = function(engineData) {
        engineData.default_messages = engineData.default_messages || {};
        $scope.welcomeMessage = messageService.arrayToMessage(engineData.welcome_message);
        if (!$scope.welcomeMessage || ($scope.welcomeMessage.type === 'text' && !$scope.welcomeMessage.body)) {
            $scope.welcomeMessage = messageService.arrayToMessage($scope.defaultWelcomeMessage);
        }

        $scope.keywordsMessagesArray = [];
        $scope.defaultMessages = messageService.arraysToMessages(engineData.default_messages.messages) || [];
        $scope.defaultMessagesId = engineData.default_messages.id || uuid4.generate();
        var keywordsMessages = engineData.keywords_messages || [];

        if (typeof(keywordsMessages) !== 'undefined') {
            keywordsMessages.forEach(function(keywordsMessages) {
                $scope.keywordsMessagesArray.push({
                    keywords: keywordsMessages.keywords,
                    messages: messageService.arraysToMessages(keywordsMessages.messages),
                    id: keywordsMessages.id
                });
            });
        }

        $timeout(recalculateListHeight, 0);
    };

    $scope.formatScopeData = function() {
        var data = {};
        var parsedKeywords;

        data.welcome_message = messageService.messageToArray($scope.welcomeMessage);
        data.default_messages = {
            id: $scope.defaultMessagesId,
            messages: messageService.messagesToArrays($scope.defaultMessages)
        };
        data.keywords_messages = [];

        $scope.keywordsMessagesArray.forEach(function(keywordsMessages) {
            parsedKeywords = parseTags(keywordsMessages.keywords);
            if (parsedKeywords.length > 0 || keywordsMessages.messages.length > 0) {
                data.keywords_messages.push({
                    id: keywordsMessages.id,
                    keywords: parsedKeywords,
                    messages: messageService.messagesToArrays(keywordsMessages.messages)
                });
            }
        });
        // fixes an edge case, when a new rule is added and then a save occurs it should save the new rule
        if ($scope.newKeywordsMessages.messages.length !== 0 || $scope.newKeywordsMessages.keywords.length !== 0) {
            data.keywords_messages.push({
                id: $scope.newKeywordsMessages.id,
                keywords: parseTags($scope.newKeywordsMessages.keywords),
                messages: messageService.messagesToArrays($scope.newKeywordsMessages.messages)
            });
        }

        return data;
    };

    $scope.persistEngine = function() {
        if ($scope.inflight) {
            $scope.pendingChanges = true;
            return;
        }
        $scope.inflight = true;
        var scopeData = $scope.formatScopeData();
        if (scopeData === null) {
            return;
        }

        Engine.update({id: $scope.engineData.id}, scopeData, function() {
            $scope.inflight = false;
            if ($scope.pendingChanges) {
                $scope.pendingChanges = false;
                $scope.persistEngine();
            }
        }, postError);

        function postError() {
            Dialog.alert('Error', 'Error trying to save engine, please try again later.');
            $scope.inflight = false;
            $scope.pendingChanges = false;

            mixpanelService.track('Error Saving Engine');
        }

        $timeout(recalculateListHeight, 0);
    };

    $scope.pasteKeywords = function(evt, array) {
        evt.preventDefault();

        function equalKeyword(kw) {
            return kw.text === cleanKeyword;
        }

        var pasted = evt.originalEvent.clipboardData.getData('text/plain').split(','),
            exists,
            cleanKeyword;
        for (var i = 0; i < pasted.length; i++) {
            cleanKeyword = pasted[i].trim();
            exists = array.filter(equalKeyword).length > 0;

            if (cleanKeyword.length > 0 && !exists) {
                array.push({text: cleanKeyword});
            }
        }

        $scope.persistEngine();
        evt.target.blur();
    };

    $scope.resetNewKeywordsMessages = function() {
        $scope.newKeywordsMessages = {
            messages: [],
            keywords: [],
            id: uuid4.generate()
        };
        $scope.showAddPanel = false;
    };

    $scope.addNewKeywordsMessages = function() {
        mixpanelService.track('Keywords Messages Added', {
            'keywordsMessages': $scope.newKeywordsMessages
        });

        $scope.keywordsMessagesArray.push($scope.newKeywordsMessages);
        $scope.resetNewKeywordsMessages();
        $scope.persistEngine();

        $timeout(recalculateListHeight, 0);
    };

    $scope.deleteKeywordsMessages = function(index) {
        Dialog.confirm('Delete', 'Are you sure you would like to delete this keyword reply?')
        .result.then(function() {
            var keywordsMessages = $scope.keywordsMessagesArray[index];

            $scope.keywordsMessagesArray.splice(index, 1);
            $scope.persistEngine();

            mixpanelService.track('Keywords Messages Removed', {
                'keywordsMessages': keywordsMessages
            });

            $timeout(recalculateListHeight, 0);
        });
    };

    $scope.openMessageEditor = function(originalMessage, index, source, sourceName) {
        if ($scope.messageEditorOpen) {
            return;
        }
        $scope.messageEditorOpen = true;

        var modalInstance = $modal.open({
            templateUrl: 'views/message-editor.html',
            windowClass: 'message-editor',
            controller: 'MessageEditorCtrl',
            backdrop: 'static',
            resolve: {
                originalMessage: function() {
                    return originalMessage;
                },
                index: function() {
                    return index;
                },
                source: function() {
                    return source;
                },
                sourceName: function() {
                    if (sourceName) {
                        return sourceName;
                    } else {
                        return null;
                    }
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.persistEngine();
            mixpanelService.track('Keywords Message Saved', {
                'message': originalMessage
            });
        }).finally(function() {
            $scope.messageEditorOpen = false;
        });
    };

    $scope.keywordsMessagesArraySortableOptions = {
        cancel: '.unsortable',
        axis: 'y',
        start: function() {
            recalculateListHeight();
        },
        create: function() {
            recalculateListHeight();
        },
        stop: function() {
            $timeout($scope.persistEngine, 0); // model sometimes isn't updated yet
            recalculateListHeight();
        }
    };

    $scope.sortableOptions = {
        cancel: '.unsortable',
        helper: 'clone',
        axis: 'y',
        update: function() {
            $timeout($scope.persistEngine, 0); // model sometimes isn't updated yet
        }
    };

    function parseTags(keywords) {
        var words = [];
        keywords.forEach(function(keyword) {
            words.push(keyword.text);
        });
        return words;
    }

    function recalculateListHeight() {
        // The reason we need to recalculate the list height is because of a scrolling issue with jQuery UI
        // sortable. If we don't do that, when the user scrolls all the way down and starts dragging a rule, it will
        // automatically scroll up (because element gets removed then added again, document height changes).
        // http://stackoverflow.com/questions/1735372/jquery-sortable-list-scroll-bar-jumps-up-when-sorting
        resetListHeight();
        $('.keywords-messages-list').height($('.keywords-messages-list').height());
    }

    function resetListHeight() {
        $('.keywords-messages-list').css('height', 'auto');
    }

    $scope.init('keyword', $scope.formatEngineResponseData);
}]);
